let slideIndex = 1;
let mobileSlideIndex=1;

showSlides(slideIndex);
showSlidesMobile(mobileSlideIndex);


// Next/previous controls
function plusSlides(n) {
  
  showSlides(slideIndex += n);
}

// Thumbnail image controls
function currentSlide(n) {
  showSlides(slideIndex = n);
}

function showSlides(n) {
  let i;
  let slides = document.getElementsByClassName("slide");
  let dots = document.getElementsByClassName("slide-show-dots");
  if (n > slides.length) {slideIndex = 1}
  if (n < 1) {slideIndex = slides.length}

  console.log("i="+i);
  console.log("length slides:"+slides.length);
  console.log("dots.length:"+dots.length);
  for (i = 0; i < slides.length; i++) {
    slides[i].style.display = "none";
  }
  for (i = 0; i < dots.length; i++) {
    dots[i].className = dots[i].className.replace(" custom-index-slideshow-active", "");
  }
  slides[slideIndex-1].style.display = "block";
  dots[slideIndex-1].className += " custom-index-slideshow-active";
}







// Next/previous controls
function plusSlidesMobile(n) {
  
  showSlidesMobile(mobileSlideIndex += n);
}

// Thumbnail image controls
function currentSlideMobile(n) {
  showSlidesMobile(mobileSlideIndex = n);
}


function showSlidesMobile(n) {
  let i;
  let slides = document.getElementsByClassName("mobile-slide");
  let dots = document.getElementsByClassName("mobile-slide-show-dots");
  if (n > slides.length) {mobileSlideIndex = 1}
  if (n < 1) {mobileSlideIndex = slides.length}

  console.log("i="+i);
  console.log("length slides:"+slides.length);
  console.log("dots.length:"+dots.length);
  for (i = 0; i < slides.length; i++) {
    slides[i].style.display = "none";
  }
  for (i = 0; i < dots.length; i++) {
    dots[i].className = dots[i].className.replace(" mobile-custom-index-slideshow-active", "");
  }
  slides[mobileSlideIndex-1].style.display = "block";
  dots[mobileSlideIndex-1].className += " mobile-custom-index-slideshow-active";
}